import './assets/css/App.css';
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  const handleRedirect = () => {
    window.location.replace('https://loknuslabs.io');
  };

  return (
    <div className="container-fluid d-flex align-items-center justify-content-center min-vh-100 bg-light">
      <div className="text-center p-5">
        <h1 className="display-4 mb-4 text-muted">TSBudd.com No Longer Active</h1>
        <p className="lead mb-4">
          This website is no longer active. Please visit my new website:
        </p>
        <button 
          className="btn btn-primary btn-lg"
          onClick={handleRedirect}
        >
          Go to Loknus Labs
        </button>
        <p className="mt-3 text-muted small">
          <a 
            href="https://loknuslabs.io" 
            className="text-decoration-none"
            onClick={(e) => {
              e.preventDefault();
              handleRedirect();
            }}
          >
            https://loknuslabs.io
          </a>
        </p>
      </div>
    </div>
  );
}

export default App;
